import { Typography, DatePicker } from "antd";
import dayjs from "dayjs";
import locale from "antd/es/date-picker/locale/tr_TR";
import "dayjs/locale/tr";

import { DatePickerContainer } from "./styles";

interface DatePickerComponentProps {
	title?: string;
    style?: React.CSSProperties;
    isRequired?: boolean;
    value?: dayjs.Dayjs | null;
    onChange?: (dateString:string) => void;
    placeholder?: string;
	error?: boolean;
	disableFutureDates?: boolean;
	disablePastDates?: boolean;
	disableToday?: boolean;
	allowClear?: boolean;
	isDisabled?: boolean;
}

const DatePickerComponent = ({
	title,
	style,
	isRequired = false,
	value = null,
	onChange,
	placeholder = "Lütfen seçiniz",
	error = false,
	disableFutureDates = false,
	disablePastDates = false,
	disableToday = false,
	allowClear = false,
	isDisabled = false
}: DatePickerComponentProps) => {
	const status = error ? "error" : undefined;

	const disabledDate = (current: dayjs.Dayjs) => {
		if (disableToday && current.isSame(dayjs(), "day")) {
			return true;
		}
		if (disableFutureDates) {
			return current && current > dayjs().endOf("day");
		}
		if (disablePastDates) {
			return current && current < dayjs().startOf("day");
		}
		return false;
	};

	const handleDateChange = (date: dayjs.Dayjs | null) => {
		console.log("date", date);
		if (onChange) {
			const formattedDate = date ? date.format("YYYY-MM-DD") : "";
			onChange(formattedDate);
		}
	};
	
	const handleBlur = (e: any) => {
		let rawInput = e.target.value;
		let date, isValidDate = false;
	
		const normalizeInput = (input:any) => {
			if (/^\d{8}$/.test(input)) {
				input = input.replace(/^(\d{2})(\d{2})(\d{4})$/, "$1.$2.$3");
			}
			return input.split(".").map((part:any) => part.padStart(2, "0")).join(".");
		};
	
		rawInput = normalizeInput(rawInput);
		const correctFormatRegex = /^(\d{2})\.(\d{2})\.(\d{4})$/;
	
		if (correctFormatRegex.test(rawInput)) {
			date = dayjs(rawInput, "DD.MM.YYYY", true);
			isValidDate = date.format("DD.MM.YYYY") === rawInput;
		}
	
		if (isValidDate && date && date.isValid()) {
			handleDateChange(date);
		} else {
			console.error("Invalid date:", rawInput);
		}
	};
	
	return (
		<DatePickerContainer>
			<Typography.Title level={5} style={{ color: "#2e333e" }}>
				{title}
				{isRequired && <span style={{ color: "red" }}>&nbsp;&nbsp;*</span>}
			</Typography.Title>
			<DatePicker
				style={{ width: "160px", ...style }}
				size="large"
				status={status}
				value={value}
				format={"DD.MM.YYYY"} 
				onChange={handleDateChange}
				onBlur={handleBlur}
				placeholder={placeholder}
				locale={locale}
				allowClear={allowClear}
				disabledDate={disabledDate}
				disabled={isDisabled}
			/>
		</DatePickerContainer>
	);
};

export default DatePickerComponent;
